// removed by extract-text-webpack-plugin
module.exports = {"contentsHolder":"src-styles----layout-module---contentsHolder---OFX5S","header":"src-styles----layout-module---header---3KFj2","activeHeaderLink":"src-styles----layout-module---activeHeaderLink---3DpX_","logo":"src-styles----layout-module---logo---3tWHQ","footer":"src-styles----layout-module---footer---1tUy7"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/layout.module.scss
// module id = 344
// module chunks = 114276838955818